module.exports = __webpack_public_path__ + "static/img/teo.d42ab66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/images/teo.png
// module id = V1Fa
// module chunks = 3